import Bookmarks from "./bookmarks";

new Bookmarks();

window.dispatchEvent(
    new Event('jobs-loaded')
);

$('#apply-now').on('click', function () {
    if (window.isBot) {
        return;
    }
    $('#sidebar-buttons-container').hide();
    $('#apply-now-container').show();
    $('#apply-email').focus();
})

window.applyNow = function () {
    $('label[for="apply-yes"]').css('color', 'black');

    const agreed = $('#apply-yes').is(':checked');

    if (! agreed) {
        $('label[for="apply-yes"]').css('color', 'red');
        grecaptcha.reset();
        return;
    }


    const jobId = $('#job-id').val();
    $('#apply-now-feedback').hide();
    $('#apply-now-error').hide();
    $('#apply-email').attr('disabled', true);
    $('#apply-button').attr('disabled', true);
    $.post(`jobs/${jobId}/apply`, {
        _token: $('[name="_token"]').val(),
        email: $('#apply-email').val(),
        agreedAt: $('#apply-yes').is(':checked'),
        "g-recaptcha-response": $('#g-recaptcha-response').val(),
    }, function (response) {
        $('#sidebar-buttons-container').show();
        $('#apply-now-container').hide();
        $('#apply-email').val('');

        $('#apply-email').attr('disabled', false);
        $('#apply-button').attr('disabled', false);

        $('#apply-now-feedback').find('.company-name').html(response.message);
        $('#apply-now-feedback').show()
        setTimeout(function () {
            $('#apply-now-feedback').fadeOut(1000);
        }, 3000);

        grecaptcha.reset()
    }).fail(function () {
        $('#apply-email').attr('disabled', false);
        $('#apply-button').attr('disabled', false);

        $('#apply-now-error').show();
        setTimeout(function () {
            $('#apply-now-error').fadeOut(1000);
        }, 3000);

        grecaptcha.reset()
    });
}

$('#apply-now-form').on('submit', function (event) {
    event.preventDefault();
});
